import { render, staticRenderFns } from "./FormRO07.vue?vue&type=template&id=840e8f6a"
import script from "./FormRO07.vue?vue&type=script&lang=js"
export * from "./FormRO07.vue?vue&type=script&lang=js"
import style0 from "./FormRO07.vue?vue&type=style&index=0&id=840e8f6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports